import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'

import SignalsComponent from '../../Signals'

import acl from '../../../../../../../../../services/acl'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

@hocBlock(config.modules.report.key, { levelReload: true })
@acl
export default class SyntheticIndicators extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        scrollTo: PropTypes.func.isRequired,
        scrollRefs: PropTypes.object.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    render() {
        const { module, block, customData, id, level, data, scrollTo, scrollRefs } = this.props

        const signals = _.omit(data, 'empty')

        return (
            <div className={cx('synthetic-indicators')}>
                <SignalsComponent
                    getContextItems={this.getContextItems}
                    mainId={id}
                    module={module}
                    customData={customData}
                    block={block}
                    level={level}
                    data={signals}
                    scrollTo={scrollTo}
                    scrollRefs={scrollRefs}
                />
            </div>
        )
    }
}
